import http from "../utilities/http-common"

const getidEntiteInfo = (idEntite) => {
  return http.get('/api/v1/entities/' + idEntite)
  };
  
  export default {
    getidEntiteInfo

  };